import { useMemo } from 'react';
import LangEnum from '../../../../../../../../lang/LangEnum';
import useGetSelloutMessage from '../../../../../../../sellout/hooks/useGetSelloutMessage';
import { useSelloutTableData } from '../hooks/useSelloutTableData';
import {
  BaseTableRowConfig,
  UseSelloutTableConfigProps,
} from './types/useSelloutTableConfig.types';

export const useSelloutTableConfig = ({ selloutProductColor }: UseSelloutTableConfigProps) => {
  const { getSelloutModalMessage } = useGetSelloutMessage();

  const {
    soldData,
    stockData,
    invoicedData,
    purchasedData,
    sortedSkuBySizePosition,
    totalQuantitySold,
    totalAvailableAmount,
    totalInvoicedQuantity,
    totalPurchasedAmount,
  } = useSelloutTableData({
    selloutProductColor,
  });

  const tableRowsConfig: BaseTableRowConfig[] = useMemo(
    () => [
      {
        titleKey: LangEnum.GLOBAL_SOLD,
        total: totalQuantitySold,
        data: soldData,
        subtitle: getSelloutModalMessage(),
      },
      {
        titleKey: LangEnum.GLOBAL_CURRENT_STOCK,
        total: totalAvailableAmount,
        data: stockData,
      },
      {
        titleKey: LangEnum.GLOBAL_TO_INVOICE,
        total: totalInvoicedQuantity,
        data: invoicedData,
      },
      {
        titleKey: LangEnum.GLOBAL_TOTAL_PURCHASED,
        total: totalPurchasedAmount,
        data: purchasedData,
      },
    ],
    [
      soldData,
      stockData,
      invoicedData,
      purchasedData,
      totalQuantitySold,
      totalAvailableAmount,
      totalPurchasedAmount,
      totalInvoicedQuantity,
      getSelloutModalMessage,
    ],
  );

  return {
    sortedSkuBySizePosition,
    tableRowsConfig,
  };
};
